import "./masthead/masthead.js";

document.addEventListener("DOMContentLoaded", function () {
	// --- Mobile Menu Logic ---
	const menuOverlay = document.getElementById("mobile-menu");
	const menuCloseButton = document.querySelector(".mobile-menu-close");
	const menuToggleButton = document.querySelector(".mobile-menu-toggle");
	const mainBottomList = document.getElementById("mobile-bottom-main");
	const subPanels = document.querySelectorAll(".bottom-sub-panel");

	if (menuOverlay && menuCloseButton && menuToggleButton) {
		menuToggleButton.addEventListener("click", function () {
			const isHidden = menuOverlay.getAttribute("aria-hidden") === "true";
			menuOverlay.setAttribute(
				"aria-hidden",
				isHidden ? "false" : "true"
			);
			menuToggleButton.setAttribute("aria-expanded", isHidden);
		});

		menuCloseButton.addEventListener("click", function () {
			menuOverlay.setAttribute("aria-hidden", "true");
			menuToggleButton.setAttribute("aria-expanded", "false");
			if (mainBottomList) mainBottomList.style.display = "block";
			subPanels.forEach((panel) => {
				panel.classList.remove("active");
				panel.setAttribute("aria-hidden", "true");
			});
			// Close all mobile nav accordions when overlay closes
			menuOverlay.querySelectorAll("details[data-mobile-nav-details][open]").forEach((d) => {
				d.removeAttribute("open");
				const sum = d.querySelector(".mobile-nav-summary");
				if (sum) sum.setAttribute("aria-expanded", "false");
			});
		});
	}

	// --- Mobile nav accordion: single-open (one section open at a time)
	const mobileNavDetails = document.querySelectorAll("#mobile-menu details[data-mobile-nav-details]");
	mobileNavDetails.forEach((details) => {
		const summary = details.querySelector(".mobile-nav-summary");
		details.addEventListener("toggle", function () {
			if (!summary) return;
			summary.setAttribute("aria-expanded", details.open ? "true" : "false");
			if (details.open) {
				mobileNavDetails.forEach((other) => {
					if (other !== details && other.open) {
						other.removeAttribute("open");
						const otherSum = other.querySelector(".mobile-nav-summary");
						if (otherSum) otherSum.setAttribute("aria-expanded", "false");
					}
				});
			}
		});
	});

	// --- Sub-panel Navigation ---
	const submenuToggleButtons = document.querySelectorAll(
		".bottom-item-button"
	);
	submenuToggleButtons.forEach((button) => {
		const targetSel = button.getAttribute("data-submenu");
		const targetPanel = document.querySelector(targetSel);
		if (targetPanel) {
			button.addEventListener("click", function () {
				mainBottomList.style.display = "none";
				subPanels.forEach((panel) => {
					panel.classList.remove("active");
					panel.setAttribute("aria-hidden", "true");
				});
				targetPanel.classList.add("active");
				targetPanel.setAttribute("aria-hidden", "false");
			});
		}
	});

	// --- Sub-panel Close ---
	const subPanelCloseButtons = document.querySelectorAll(".sub-panel-close");
	subPanelCloseButtons.forEach((closeBtn) => {
		closeBtn.addEventListener("click", function () {
			const parentPanel = closeBtn.closest(".bottom-sub-panel");
			if (parentPanel) {
				parentPanel.classList.remove("active");
				parentPanel.setAttribute("aria-hidden", "true");
			}
			mainBottomList.style.display = "block";
		});
	});

	// --- Desktop Sub-menu Animation ---
	const navItems = document.querySelectorAll(".bottom-nav-item");
	navItems.forEach((item) => {
		const submenu = item.querySelector(".bottom-sub-menu");
		if (submenu) {
			item.addEventListener("mouseenter", () => {
				const columns = submenu.querySelectorAll(".sub-menu-col");
				if (typeof gsap !== "undefined") {
					gsap.set(columns, { opacity: 0, x: -100 });
					gsap.to(columns, {
						duration: 0.6,
						x: 0,
						opacity: 1,
						stagger: 0.2,
						ease: "power1.out",
					});
				}
			});
		}
	});

	// --- Login Form Logic ---
	const loginLink = document.getElementById("login");
	const loginMobileLink = document.getElementById("login_m");
	const loginFormContainer = document.getElementById("login-form-container");
	const loginFormClose = document.querySelector(".login-form-close");

	function showLoginForm() {
		loginFormContainer.classList.add("active");
	}
	function hideLoginForm() {
		loginFormContainer.classList.remove("active");
	}

	if (loginLink && loginFormContainer) {
		loginLink.addEventListener("click", function (e) {
			e.preventDefault();
			loginFormContainer.classList.remove("mobile-slide");
			showLoginForm();
		});
	}
	if (loginMobileLink && loginFormContainer) {
		loginMobileLink.addEventListener("click", function (e) {
			e.preventDefault();
			loginFormContainer.classList.add("mobile-slide");
			loginFormContainer.style.display = "block";
			if (typeof gsap !== "undefined") {
				gsap.fromTo(
					loginFormContainer,
					{ x: "100%", opacity: 0 },
					{ duration: 0.5, x: "0%", opacity: 1, ease: "power2.out" }
				);
			}
		});
	}
	if (loginFormClose && loginFormContainer) {
		loginFormClose.addEventListener("click", function () {
			if (window.innerWidth <= 768 && typeof gsap !== "undefined") {
				gsap.to(loginFormContainer, {
					duration: 0.5,
					x: "100%",
					opacity: 0,
					ease: "power2.in",
					onComplete: function () {
						loginFormContainer.classList.remove(
							"active",
							"mobile-slide"
						);
						loginFormContainer.style.display = "none";
					},
				});
			} else {
				hideLoginForm();
			}
		});
	}

	// --- Back to Top Button ---
	const header =
		document.getElementById("masthead") ||
		document.querySelector("header") ||
		document.body;
	const backToTop = document.getElementById("back-to-top");
	if (backToTop) {
		let showWhen = header ? header.offsetHeight + header.offsetTop : 150;
		window.addEventListener("scroll", function () {
			if (window.scrollY > showWhen) {
				backToTop.classList.add("show");
			} else {
				backToTop.classList.remove("show");
			}
		});
		backToTop.addEventListener("click", function () {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}

	// --- User Panel Logic ---
	var userIcon = document.getElementById("user-nav-link");
	var userPanel = document.getElementById("user-panel");
	document.addEventListener("mousedown", function (e) {
		if (
			userPanel &&
			userIcon &&
			!userPanel.contains(e.target) &&
			!userIcon.contains(e.target)
		) {
			userPanel.style.display = "none";
		}
	});
	if (userIcon && userPanel) {
		userIcon.addEventListener("mouseenter", function () {
			userPanel.style.display = "block";
		});
		userIcon.addEventListener("click", function (e) {
			e.preventDefault();
			userPanel.style.display =
				userPanel.style.display === "block" ? "none" : "block";
		});
		userIcon.addEventListener("focus", function () {
			userPanel.style.display = "block";
		});
		userPanel.addEventListener("mouseleave", function () {
			userPanel.style.display = "none";
		});
	}

	// --- Adpost GSAP/ScrollTrigger Logic ---
	if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
		document
			.querySelectorAll("article.adpost, article.adpost-in-archive")
			.forEach(function (adArticle) {
				gsap.set(adArticle, { autoAlpha: 0, y: 40 });
				ScrollTrigger.create({
					trigger: adArticle,
					start: "top 85%",
					once: true,
					onEnter: function () {
						gsap.to(adArticle, {
							duration: 0.75,
							autoAlpha: 1,
							y: 0,
							ease: "power3.out",
						});
						const container = adArticle.querySelector(
							".ad-iframe-container"
						);
						if (container && !container.dataset.iframeLoaded) {
							const iframe = container.querySelector("iframe");
							if (iframe && iframe.dataset.src) {
								iframe.src = iframe.dataset.src;
								container.dataset.iframeLoaded = "1";
							}
						}
					},
				});
			});
	}

	//Event Card Class
	const eventItems = document.querySelectorAll(".event-card");
	if (eventItems) {
		//foreach eventItems
		//check for nonempty links, on mouseover add class to card 'event-card--hover'
		//remove class when mouseover is complete
		eventItems.forEach((card) => {
			const links = card.querySelectorAll("a[href]");
			links.forEach((link) => {
				link.addEventListener("mouseenter", () => {
					card.classList.add("event-card--hover");
				});
				link.addEventListener("mouseleave", () => {
					// Check if any link is still hovered
					const isAnyHovered = Array.from(links).some((l) =>
						l.matches(":hover")
					);
					if (!isAnyHovered) {
						card.classList.remove("event-card--hover");
					}
				});
			});
		});
	}
});
